import { setCMSBarWidth } from './cms-bar-width'
import { appendVersions } from './site-common'
import './select_checkbox'
import './required_checkbox'
import './setup-footer-collapse'
import { initDomainsBanner } from './domains-banner'
import { initMenuSticky } from './menu_sticky'
import { initMenuControl } from './menu_control'
import { initFacebookTracker } from './facebook-tracker'
import {
    collapseAddNameToItems,
    collapseOpenItemWhenFragment,
    openAccordingCollapse,
} from './collapse'

document.addEventListener('DOMContentLoaded', () => {
    // Because message 'Enter a valid email address.' is hidden.
    for (const email of document.querySelectorAll('.base-form input[type=email].has-error')) {
        if (email.value) {
            email.classList.add('email-error')
        }

        email.addEventListener('input', () => {
            email.classList.remove('email-error')
        })
    }

    for (const svg of document.querySelectorAll('.cooperation aside img')) {
        svg.insertAdjacentHTML('afterend', `<div class="info-tooltip" >${svg.alt}</div>`)
    }

    for (const item of document.querySelectorAll('.prevent-default')) {
        item.href = ''
    }

    // Add subject for link with mailto
    for (const link of document.querySelectorAll('a[href^="mailto"]')) {
        if (link.dataset.subject) {
            link.href = `${link.href}?subject=${link.dataset.subject}`
        }
    }

    // Open first nav tab, nav pills
    for (const tabs of document.querySelectorAll('ul[role="tablist"][class*="nav-"].nav')) {
        tabs.querySelector('.nav-item button').click()
    }

    // If url has hash try to open collapse
    if (window.location.hash) {
        if (document.getElementById(`${window.location.hash.replace('#', '')}`)) {
            document.getElementById(`${window.location.hash.replace('#', '')}`).click()
        }
    }

    // Open navigation items in a new tab
    for (const link of document.querySelectorAll('.page-navigation a[href]')) {
        if (!link.href.includes(window.location.host)) {
            link.setAttribute('target', '_blank')
        }
    }

    openAccordingCollapse()
    collapseAddNameToItems()
    collapseOpenItemWhenFragment()
    initMenuSticky()
    initMenuControl()
    initDomainsBanner()
    initFacebookTracker()

    const structure = document.querySelector('.cms-toolbar-item-cms-mode-switcher > a:not(.cms-btn-disabled)')
    if (structure) {
        structure.addEventListener('click', () => { setTimeout(setCMSBarWidth, 1000) }, true)
    }

    appendVersions(document.querySelector('.cms-toolbar-item-logo a'))

    const catalogDetail = document.querySelector('.common-catalog.detail')
    if (catalogDetail) {
        const catalogItem = catalogDetail.querySelector('.catalog-item')
        const positionTitle = catalogItem.classList[1] || null

        if (positionTitle) {
            const catalogTitle = document.querySelector(`.common-catalog.inzeraty .${positionTitle}`)
            catalogTitle.classList.add('catalog-item-hover')
            catalogTitle.removeAttribute('href')
        }
    }

    // If there are no current auctions, open the future auctions tab
    const auctionsList = document.querySelector('section.auctions-list')
    const inAuction = auctionsList?.querySelector('.auctions-list.in_auction')
    const tableIsEmpty = inAuction?.querySelector('tbody tr td[colspan="6"]')
    const navItem = auctionsList?.querySelector('.nav-tabs .nav-item:nth-of-type(2) button[data-bs-toggle="tab"]')

    if (tableIsEmpty && navItem) {
        navItem.click()
    }
})

import './cms_toolbar'
